import React from 'react';
import PropTypes from 'prop-types';
import Icons from '../../../../core/modules/common/components/Icons';

const HeaderChartButton = (props) => {
  const {
    title,
    action,
    chartMeta,
  } = props;

  return (
    <div>
      <span className="header-chart-button__title">{title}</span>
      <button
        className="header-chart-button__button"
        style={{ marginLeft: '6px' }}
        onClick={() => { action(chartMeta); }}
        type="button"
      >
        <Icons.Custom name="bar-chart" />
      </button>
    </div>
  );
};

HeaderChartButton.propTypes = {
  action: PropTypes.func,
  chartMeta: PropTypes.objectOf(PropTypes.shape),
  title: PropTypes.string,
};

export default HeaderChartButton;
